import { useRef } from 'react';

import { usePatientByUrlParam } from '../../../features/patients';
import { useFetchCuffMeasurements, useFetchPhysiologicalData } from '../../../features/physiological-data';
import { Card } from '../../common';
import { DetailedBpBraceletList } from '../detailed-bp-bracelet-list';
import { DetailedBpCuffList } from '../detailed-bp-cuff-list';
import { PatientSummary, PressureChart, StatisticsHeaderBar } from './components';

export const Patient = () => {
  const patient = usePatientByUrlParam();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useFetchPhysiologicalData(patient);
  useFetchCuffMeasurements(patient);

  return (
    <div id="patientPhysiologicalDataWrapper">
      <PatientSummary patient={patient} />

      <Card ref={wrapperRef}>
        <StatisticsHeaderBar wrapperRef={wrapperRef} />
        <PressureChart wrapperRef={wrapperRef} />
        <DetailedBpBraceletList />
        <DetailedBpCuffList />
      </Card>
    </div>
  );
};
